"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonImage = void 0;
var ButtonImage;
(function (ButtonImage) {
    ButtonImage["REFRESH"] = "btn-with-refresh-image";
    ButtonImage["CLOSE"] = "btn-with-close-image";
    ButtonImage["ARROW_LEFT"] = "btn-with-arrow-left-image";
    ButtonImage["ARROW_RIGHT"] = "btn-with-arrow-right-image";
    ButtonImage["PLUS"] = "btn-with-plus-image";
})(ButtonImage = exports.ButtonImage || (exports.ButtonImage = {}));
exports.default = ButtonImage;
//# sourceMappingURL=ButtonImage.js.map